// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2hfzL","colMin":"styles_colMin__-m8u5","colCheckbox":"styles_colCheckbox__mNi3i"};